<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <div v-for="b in blocks">
        <h4>
          <span style="border-bottom: 1px dashed">{{ b.UF_NAME }}</span>
        </h4>
        <div class="dz-blocks" v-for="l in b.LIST_TYPE">
          <template v-if="l.NAME">
            <b
              v-if="b.UF_CODE === 'contractors'"
              @click="showContractor(l.ID, l.TYPE_DOC_LIST, b.UF_CODE, l)"
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>
            <b
              v-if="b.UF_CODE === 'procuring' && l.UF_IS_BLOCK_SUM"
              @click="showProc1(l.ID, l.TYPE_DOC_LIST, b.UF_CODE, l)"
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>
            <b
              v-if="b.UF_CODE === 'procuring' && l.UF_IS_BLOCK_PARTNER"
              @click="showContractor(l.ID, l.TYPE_DOC_LIST, b.UF_CODE, l)"
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>
            <b
              v-if="
                b.UF_CODE === 'procuring' &&
                  !l.UF_IS_BLOCK_SUM &&
                  !l.UF_IS_BLOCK_PARTNER &&
                  !l.UF_IS_BLOCK_ZALOG
              "
              @click="
                showProc2(l.ID, l.NAME, '', l.TYPE_DOC_LIST, b.UF_CODE, l)
              "
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>
            <b
              v-if="
                b.UF_CODE === 'addBlockZalogFaceBlock' &&
                  l.CODE === 'addBlockZalogFace'
              "
              @click="addZalogFaceShag1(l)"
            >
              <a class="add-t-r"></a> {{ l.NAME }}
            </b>

            <template
              v-if="
                b.UF_CODE === 'addBlockZalogFaceBlock' &&
                  l.CODE === 'isBlockZalogFace'
              "
            >
              <table>
                <tr>
                  <td>
                    <b> - Залогодатель {{ l.NAME }} </b>
                  </td>
                  <td>
                    <i
                      @click="deleteZalogFace(l.ID)"
                      class="i-delete centerIcon"
                      style="margin: 0 10px; float: right;"
                    ></i>
                  </td>
                </tr>
              </table>

              <div class="div-zalog">
                <template v-for="t in l.SECTION_TYPE_DOC_LIST">
                  <p @click="addBlockDocumentsZalogType(l, t)">
                    <a class="add-t-r"></a> Добавить блок <b>{{ t.NAME }}</b>
                  </p>
                </template>
              </div>
            </template>

            <!--<b v-if="l.UF_IS_BLOCK_ZALOG" @click="showProcZalogType(l.ID, l)">
               <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
             </b>-->

            <b
              v-if="
                b.UF_CODE === 'suspension_conditions' &&
                  l.CODE !== 'maturity_subordination'
              "
              @click="showProc2(l.ID, '', '', l.TYPE_DOC_LIST, b.UF_CODE, l)"
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>

            <b
              v-if="
                b.UF_CODE === 'suspension_conditions' &&
                  l.CODE === 'maturity_subordination'
              "
              @click="
                showProc2(l.ID, '', l.NAME, l.TYPE_DOC_LIST, b.UF_CODE, l)
              "
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>

            <b
              v-if="
                b.UF_CODE === 'powers_of_attorney' || b.UF_CODE === 'tranches'
              "
              @click="
                showProc2(l.ID, '', l.NAME, l.TYPE_DOC_LIST, b.UF_CODE, l)
              "
            >
              <a class="add-t-r"></a> Добавить блок "{{ l.NAME }}"
            </b>

            <div style="clear: both"></div>
          </template>
        </div>

        <div></div>
      </div>

      <div
        class="modal fade in"
        v-bind:class="{ show: showProc1dialog }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showProc1dialog = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Наименование гарантии/поручительства</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <input v-model="sum" type="text" class="form-control" />
                <!--<vue-numeric
                  currency=""
                  separator="space"
                  v-model="sum"
                  type="text"
                  class="form-control"
                />-->
              </div>
            </div>
            <div class="modal-footer">
              <!--<button @click="addProc" type="button" class="btn btn-primary">
                Добавить блок
              </button>-->
              <button @click="showProc3" type="button" class="btn btn-primary">
                Далее
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showProc1dialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <div
        class="modal fade in"
        v-bind:class="{ show: showProc2dialog }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showProc2dialog = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавить блок {{ addBlockName }}</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Наименование блока</label>
                <input v-model="procName" class="form-control" />
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="showProc3"
                :disabled="procName === ''"
                type="button"
                class="btn btn-primary"
              >
                {{ lType.CODE === "added_block" ? "Добавить блок" : "Далее" }}
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showProc2dialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <!-- добавление залогов -->
      <div
        class="modal fade in"
        v-bind:class="{ show: showProcZalogdialog }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showProcZalogdialog = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавить блок {{ addBlockName }}</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Выбор типа залогодателя:</label>
                <select v-model="typeZalogFace" class="form-control">
                  <option value="0"></option>
                  <option value="1">Физическое лицо</option>
                  <option value="2">Юридическое лицо</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="showProcZalogShag2"
                :disabled="typeZalogFace == 0"
                type="button"
                class="btn btn-primary"
              >
                Далее
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showProcZalogdialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <div
        class="modal fade in"
        v-bind:class="{ show: showProcZalogPhisicDialog }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showProc2dialog = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавить {{ addBlockName }}</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Укажите ФИО залогодателя:</label>
                <input v-model="procName" class="form-control" />
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="addZalogFacePhisic()"
                :disabled="procName === ''"
                type="button"
                class="btn btn-primary"
              >
                Добавить
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showProcZalogPhisicDialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <div
        class="modal fade in"
        v-bind:class="{ show: showProcViewAddBlockZalogDialog }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog " role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showProcViewAddBlockZalogDialog = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавить блок {{ addBlockName }}</h4>
            </div>
            <div
              class="modal-body"
              style="
                overflow: scroll;
                max-height: 500px;
              "
            >
              <p v-if="typeZalogFace == 1">
                Залогодатель - физическое лицо <b>{{ procName }}</b>
              </p>
              <p v-if="typeZalogFace == 2">
                Залогодатель - юридическое лицо <b>{{ companyName }}</b>
              </p>

              <h5><b>Выбор блоков документов по залогам:</b>:</h5>
              <div class="form-group">
                <div v-for="b in blocks">
                  <template
                    v-for="bType in b.LIST_TYPE"
                    v-if="bType.UF_IS_BLOCK_ZALOG"
                  >
                    <!-- block -->
                    <table class="tab-list-form">
                      <tr
                        class="padd4"
                        @click="addTempBlockSection(bType.ID, bType)"
                      >
                        <td>
                          <input
                            type="checkbox"
                            v-model="selectListBlock"
                            :id="bType.ID"
                            :value="bType.ID"
                          />
                        </td>
                        <td class="name">
                          <b>{{ bType.NAME }}</b>
                        </td>
                      </tr>
                    </table>

                    <!--document block -->
                    <div
                      style="padding-left: 25px;"
                      v-show="isViewShowSectionBlock(bType.ID)"
                    >
                      <h5><b>Выбор документов</b>:</h5>
                      <table
                        v-for="bTypeBlockType in bType.TYPE_DOC_LIST"
                        class="tab-list-form"
                      >
                        <tr
                          class="padd4"
                          v-if="bType.UF_IS_BLOCK_ZALOG"
                          @click="addTempSection(bTypeBlockType.ID)"
                        >
                          <td>
                            <input
                              type="checkbox"
                              v-model="selectListType"
                              :id="bTypeBlockType.ID"
                              :value="bTypeBlockType.ID"
                            />
                          </td>
                          <td class="name">
                            <span v-html="bTypeBlockType.NAME"></span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="eddStepBlockTypeZalogVariantRequest"
                :disabled="selectListBlock.length == 0"
                type="button"
                class="btn btn-primary"
              >
                Добавить блок
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showProcViewAddBlockZalogDialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end добавление залогов -->

      <!-- добавление организации var 1-->
      <!--      <div
        class="modal fade in"
        v-bind:class="{ show: showResident }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showResident = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Укажите тип контрагента</h4>
            </div>
            <div class="modal-body">
              <select v-model="resident" class="form-control">
                <option :value="1">Российская компания</option>
                <option :value="2">Иностранная компания</option>
                <option :value="3">Не определено</option>
              </select>
            </div>
            <div class="modal-footer">
              <button
                @click="setResident"
                type="button"
                class="btn btn-primary"
              >
                Далее
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showResident = false"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade in"
        v-bind:class="{ show: showCompIn }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showCompIn = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавление иностранной организации</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Название организации</label>
                <input v-model="inname" class="form-control" />
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="showProc3"
                :disabled="inname === ''"
                type="button"
                class="btn btn-primary"
              >
                Добавить организацию
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="showCompIn = false"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade in"
        v-bind:class="{ show: showOgrnFind }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showOgrnFind = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавление российской организации</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>ОГРН</label>
                <input
                  v-model="ogrn"
                  class="form-control"
                  placeholder="ОГРН организации"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="addSubContact"
                type="button"
                class="btn btn-primary"
              >
                Добавить организацию
              </button>
            </div>
          </div>
        </div>
      </div>-->
      <!-- end добавление оргвнизации -->

      <!-- добавление организации var 2 -->

      <div
        class="modal fade in"
        v-bind:class="{ show: showResident }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showResident = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Добавление контрагента</h4>
            </div>
            <div class="modal-body">

              <p class="select-blue-desc">
                Начните вводить Название или ИНН/Регистрационный номер контрагента,
                затем выберите нужный из списка.
                Если ничего не найдено, добавьте нового контрагента, нажав на '+'
              </p>
              <div class="form-group">
                <div class="form-group add-row autocomplete-form-add">
                  <table>
                    <tbody>
                    <tr>
                      <td>
                        <v-autocomplete
                          :items="orgsList"
                          input-class="form-control"
                          :auto-select-one-item="false"
                          :keep-open="false"
                          :component-item="act"
                          v-model="selectedOrg"
                          ref="autoSearchInputRef"
                          :min-len="3"
                          :get-label="getLabel"
                          placeholder="Название или ИНН/Идентификационный код контрагента"
                          @update-items="searchAllOrg"
                          @change="isSearchGood = true"
                          @input="selectSearchItems"
                        ></v-autocomplete>
                      </td>
                      <td class="button-del" v-if="selectedOrg">
                        <a @click="clearAutocomplete" class="link-delete-row"></a>
                      </td>
                      <td class="button-del" v-else-if="!isSearchGood">
                        <a @click="resetAutocomplete" class="link-delete-row"></a>
                      </td>
                      <td class="button-add">
                        <a
                          class="link-add-row"
                          style="width: 20px; padding: 0;"
                          :href='getLinkOlk()'
                          title="Добавить контрагента"
                          target="_blank"></a>
                      </td>
                    </tr>
                    <tr v-if="!isSearchGood">
                      <td colspan="2">
                        <p style="text-align: left; font-style: italic;">По вашему запросу ничего не найдено, попробуйте
                          изменить запрос</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button
                @click="setResidentFindOrg"
                type="button"
                class="btn btn-primary"
                :disabled="!isAddAllOrgGood"
              >
                Далее
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showResident = false"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </div>


      <!-- end добавление оргвнизации var 2-->

      <!-- добавление типов документов -->
      <div
        class="modal fade in"
        v-bind:class="{ show: showProc3dialog }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document" style="width: 1100px;">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                v-on:click="showProc3dialog = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">{{ tempNameBlock }}</h4>
            </div>
            <div class="modal-body" v-if="allListType.length > 0">
              <h5><b>Выбор документов</b>:</h5>
              <div class="form-group">
                <table v-for="type in allListType" class="tab-list-form">
                  <tr class="padd4">
                    <td>
                      <input
                        type="checkbox"
                        v-model="selectListType"
                        :id="type.ID"
                        :value="type.ID"
                      />
                    </td>
                    <td class="name" @click="addTempSection(type.ID)">
                      <span v-html="type.NAME"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="addStepTypeVariantRequest"
                type="button"
                class="btn btn-primary"
              >
                Добавить блок
              </button>
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                v-on:click="showProc3dialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_URL } from "@/common/config";
import { ProjectsService } from "@/common/api.service";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";
import Item from "@/components/expert/Item.vue";

export default {
  components: {},
  props: [
    "docs",
    "documentConf",
    "index",
    "project",
    "documentHistory",
    "blocks"
  ],
  name: "BlocksDZ",
  data() {
    return {
      showResident: false,
      showConfirm: false,
      showCompIn: false,
      showOgrnFind: false,
      showProc1dialog: false,
      showProc2dialog: false,
      showProc3dialog: false,
      showProcZalogdialog: false,
      showProcZalogPhisicDialog: false,
      showProcViewAddBlockZalogDialog: false,
      ogrn: "",
      addBlockID: 0,
      addBlockName: "",
      resident: 1,
      inname: "",
      registrationNumber: "",
      incountry: 0,
      sum: 0,
      procName: "",
      tempNameBlock: "",
      tempCodeBlock: "",
      companyName: "",
      companyId: "",
      allListType: [],
      selectListType: [],
      selectListBlock: [],
      lType: [],
      typeZalogFace: 0,
      idFaceZalog: 0,
      selectedOrg: "",
      orgsList: [],
      act: Item,
      isViewNameOrg: false,
      isSearchGood: true,
      isAddAllOrgGood: false,
      dataOlk: []
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country"]);
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    // await this.loadBlocks();
  },
  methods: {
    /*async loadBlocks() {
      await ProjectsService.getBlockDocumentDZ(this.$route.params.id).then(
        async ({ data }) => {
          this.blocks = await data;
        },
        this
      );
    },*/
    updateDocInfo() {
      ProjectsService.getDocumentDZProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          this.documentConf.FILE_ACCEPT_INFO = data.FILE_ACCEPT_INFO;
          this.documentConf.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH;
          this.documentConf.LIST_TYPE = data.LIST_TYPE;
          this.documentConf.SHOW_SAVE_SESSION = data.SHOW_SAVE_SESSION;
          this.documentConf.IS_BLOCK_BUTTON_SET_VERSION =
            data.IS_BLOCK_BUTTON_SET_VERSION;
          console.log(data);
        },
        this
      );
    },
    addTempSection(id) {
      if (this.selectListType.indexOf(id) != -1) {
        this.selectListType = this.selectListType.filter(function(f) {
          return f !== id;
        });
      } else {
        this.selectListType.push(id);
      }
    },
    addTempBlockSection(id, block) {
      if (this.selectListBlock.indexOf(id) != -1) {
        this.selectListBlock = this.selectListBlock.filter(function(f) {
          return f !== id;
        });

        block.TYPE_DOC_LIST.forEach(function(list) {
          if (this.selectListType.indexOf(list.ID) != -1) {
            this.selectListType = this.selectListType.filter(function(f2) {
              return f2 !== list.ID;
            });
          }
        }, this);
      } else {
        this.selectListBlock.push(id);

        block.TYPE_DOC_LIST.forEach(function(list) {
          if (this.selectListType.indexOf(list.ID) === -1) {
            this.selectListType.push(list.ID);
          }
        }, this);
      }
    },
    isViewShowSectionBlock(id) {
      return this.selectListBlock.indexOf(id) != -1 ? true : false;
    },
    showProc1(id, listType, blockCode, l) {
      this.showProc1dialog = true;
      this.addBlockID = id;
      this.sum = "";
      this.procName = "";
      this.tempCodeBlock = blockCode;
      this.allListType = listType;
      this.lType = l;
      this.idFaceZalog = 0;
    },
    showProcZalogType(id, l) {
      this.showProcZalogdialog = true;
      this.addBlockID = id;
      this.typeZalogFace = 0;
      this.ogrn = "";
      this.sum = "";
      this.procName = "";
      this.addBlockName = " документов по Залогам";
      this.lType = l;
      this.selectListType = [];
      this.selectListBlock = [];
      this.addTempBlockSection(id, l);
    },

    addZalogFaceShag1(l) {
      this.showProcZalogdialog = true;
      this.addBlockID = 0;
      this.typeZalogFace = 0;
      this.ogrn = "";
      this.sum = "";
      this.procName = "";
      this.addBlockName = " Залогодателя";
      this.lType = l;
      this.selectListType = [];
      this.selectListBlock = [];
      this.tempCodeBlock = l.CODE;
    },
    addZalogFacePhisic() {
      if (this.typeZalogFace == 1) {
        //физик, добавляем
        if (this.procName !== "") {
          ProjectsService.addZalogFaceBlockDocumentDZ(this.project.ID, {
            UF_TYPE_ZALOG_FACE: this.typeZalogFace,
            UF_NAME: this.procName
          }).then(({ data }) => {
            if (!data.error) {
              this.showProcZalogPhisicDialog = false;
              this.procName = "";
              this.$toasted.show("Залогодатель успешно добавлен", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
              this.$parent.loadBlocks();
            } else {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            }
          }, this);
        }
      }
    },
    addZalogFaceOrg() {
      if (this.typeZalogFace == 2) {
        //организация, добавляем
        if (this.companyName !== "") {
          ProjectsService.addZalogFaceBlockDocumentDZ(this.project.ID, {
            UF_TYPE_ZALOG_FACE: this.typeZalogFace,
            UF_COMPANY_NAME: this.companyName,
            UF_COMPANY_ID: this.companyId,
            UF_OGRN: this.ogrn,
            DATA_OLK: this.dataOlk
          }).then(({ data }) => {
            if (!data.error) {
              this.showOgrnFind = false;
              this.companyName = "";
              this.companyId = 0;
              this.ogrn = "";

              this.$toasted.show("Залогодатель успешно добавлен", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
              this.$parent.loadBlocks();
            } else {
              this.showOgrnFind = true;
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            }
          }, this);
        }
      }
    },
    deleteZalogFace(idZalogFaceid) {
      if (confirm("Вы действительно хотите удалить залогодателя?")) {
        ProjectsService.deleteZalogFaceBlockDocumentDZ(
          this.project.ID,
          idZalogFaceid
        ).then(({ data }) => {
          if (data.error === false) {
            this.updateDocInfo();
            this.$parent.loadBlocks();
            this.$toasted.show("Залогодатель успешно удален", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        }, this);
      }
    },

    showProcZalogShag2() {

      let nextShag =
        this.typeZalogFace == 1 || this.typeZalogFace == 2 ? true : false;


      if (nextShag) {
        this.showProcZalogdialog = false;
      }

      if (this.typeZalogFace == 1) {
        //физик
        this.showProcZalogPhisicDialog = true;
      } else if (this.typeZalogFace == 2) {
        //юр лицо
        //this.showOgrnFind = true;
        this.clearAutocomplete();
        this.resetAutocomplete();
        this.showResident = true;
      }
    },
    showProc3() {
      let nextShag = false;
      //this.selectListType = [];
      let TempArr = [];
      this.allListType.forEach(function(item) {
        TempArr.push(item.ID);
      });

      this.selectListType = TempArr;

      if (
        this.tempCodeBlock === "contractors" ||
        (this.tempCodeBlock === "procuring" && this.lType.UF_IS_BLOCK_PARTNER)
      ) {
        this.showResident = false;
        if (this.resident === 1 || this.resident === 3) {
          this.tempNameBlock = this.companyName;
          this.showProc1dialog = false;
          nextShag = true;
        } else if (this.resident === 2) {
          this.showCompIn = false;
          this.tempNameBlock = this.inname;
          this.showProc1dialog = false;
          nextShag = true;
        }
      } else if (
        this.tempCodeBlock == "procuring" &&
        this.lType.UF_IS_BLOCK_SUM
      ) {
        this.resident = 0;
        if (this.sum === "") {
          this.$toasted.show("Не указана сумма гарантий", {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.tempNameBlock = this.sum;
          this.showProc1dialog = false;
          nextShag = true;
        }
      } else if (
        this.tempCodeBlock == "procuring" &&
        !this.lType.UF_IS_BLOCK_SUM &&
        !this.lType.UF_IS_BLOCK_PARTNER
      ) {
        this.tempNameBlock = this.procName;
        this.showProc2dialog = false;
        this.resident = 0;
        nextShag = true;
      } else if (
        this.tempCodeBlock == "suspension_conditions" &&
        this.lType.CODE === "maturity_subordination"
      ) {
        this.tempNameBlock = this.procName;
        this.showProc2dialog = false;
        this.resident = 0;
        nextShag = true;
      } else if (
        this.tempCodeBlock == "suspension_conditions" &&
        this.lType.CODE === "added_block"
      ) {
        this.tempNameBlock = this.procName;
        this.resident = 0;
        this.addProc();
      } else if (
        this.lType.UF_IS_BLOCK_ZALOG &&
        this.tempCodeBlock !== "addBlockZalogFace"
      ) {
        this.tempNameBlock = this.procName;
        this.resident = 0;
        nextShag = true;
      } else if (this.tempCodeBlock == "addBlockZalogFace") {
        this.showOgrnFind = true;
        if (this.resident === 1) {
          this.tempNameBlock = this.companyName;
          this.showProc1dialog = false;
          this.showResident = false;
          this.addZalogFaceOrg();
        }
      } else if (this.tempCodeBlock == "powers_of_attorney") {
        this.tempNameBlock = this.procName;
        this.showProc2dialog = false;
        this.resident = 0;
        nextShag = true;
      } else if (this.tempCodeBlock == "tranches") {
        this.tempNameBlock = this.procName;
        this.showProc2dialog = false;
        this.resident = 0;
        nextShag = true;
      }

      if (nextShag) {
        this.showProc3dialog = true;
      }
    },

    addBlockDocumentsZalogType(l, t) {
      this.idFaceZalog = l.ID;
      this.addBlockID = t.ID;

      this.addBlockName = " по залогодателю " + l.NAME + ' "' + t.NAME + '"';
      this.sum = "";
      this.tempCodeBlock = t.CODE;
      this.allListType = t.TYPE_DOC_LIST;
      this.lType = t;

      this.procName = t.NAME;
      this.showProc2dialog = false;
      this.showProc3(); //пропускаем изменение блока

      /*if (
        this.tempCodeBlock == "fin_status_zalogodatelya_phisic" ||
        this.tempCodeBlock == "fin_status_zalogodatelya"
      ) {
        this.procName = t.NAME;
        this.showProc2dialog = false;
        this.showProc3(); //пропускаем изменение блока
      } else {
        this.procName = "";
        this.showProc2dialog = true;
      }*/
    },

    showProc2(id, name, proc, listType, blockCode, l) {
      this.showProc2dialog = true;
      this.addBlockID = id;
      this.addBlockName = name;
      this.sum = "";
      this.procName = proc;
      this.tempCodeBlock = blockCode;
      this.allListType = listType;
      this.lType = l;
      this.idFaceZalog = 0;

      if (
        this.tempCodeBlock == "powers_of_attorney" ||
        this.tempCodeBlock == "tranches"
      ) {
        this.showProc3();
      }
    },
    addStepTypeVariantRequest() {
      /*if ( this.allListType.length > 0 && this.selectListType.length == 0){
        this.$toasted.show('Для добавления блока необходимо выбрать хотя бы один вид документа', {
          theme: "red",
          position: "bottom-right",
          duration: 3500
        });

      }else{*/
      if (this.resident === 1) {
        this.addSubContactRequest(); //РФ
      } else if (this.resident === 2) {
        this.addInSubContact(); //Ин агент
      } else if (this.resident === 3) {
        this.addNotDefinedSubContact(); //Не определено
      } else {
        this.addProc();
      }
      // }
    },
    eddStepBlockTypeZalogVariantRequest() {
      if (this.typeZalogFace == 1) {
        //физ лицо
        this.addProc();
      } else if (this.typeZalogFace == 2) {
        //юр лицо
        this.addSubContactRequest(); //РФ
      }
      this.selectListType = [];
      this.selectListBlock = [];
    },
    addProc() {
      ProjectsService.addBlockDocumentDZ(this.project.ID, {
        UF_SECTION_TYPE_DZ_ID: this.addBlockID,
        UF_SUM_GARANT: this.sum,
        UF_NAME_BLOCK: this.procName,
        UF_TYPE_DOC_LIST: this.selectListType,
        UF_BLOCK_ZALOG_LIST: this.selectListBlock,
        UF_ZALOG_FACE_DZ_ID: this.idFaceZalog
      }).then(({ data }) => {
        if (!data.error) {
          this.showProc1dialog = false;
          this.showProc2dialog = false;
          this.showProc3dialog = false;
          this.idFaceZalog = 0;
          this.showProcViewAddBlockZalogDialog = false;
          this.updateDocInfo();
          this.$parent.loadBlocks();
          this.$toasted.show("Блок успешно добавлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    showContractor(id, listType, blockCode, l) {
      this.showResident = true;
      this.addBlockID = id;
      this.tempCodeBlock = blockCode;
      this.allListType = listType;
      this.lType = l;
      this.idFaceZalog = 0;
    },
    showResidentWindow() {
      this.showConfirm = false;
      this.ogrn = "";
      this.showResident = true;
    },
    setResident() {
      if (this.resident === 1) {
        this.findOrg();
      }
      if (this.resident === 2) {
        this.showIn();
      }
      if (this.resident === 3) {
        this.showResident = false;
        this.companyName = "Не определено";
        this.showProc3();
        //this.addNotDefinedSubContact();
      }
    },
    showIn() {
      this.showResident = false;
      this.inname = "";
      this.incountry = 0;
      this.showCompIn = true;
    },
    findOrg() {
      this.showResident = false;
      this.ogrn = "";
      this.showOgrnFind = true;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addSubContact() {
      if (this.ogrn !== "") {
        ProjectsService.getCoAuthorInfoByOgrn(this.ogrn).then(({ data }) => {
          if (!data.IS_FIND) {
            this.$toasted.show(data.ERROR, {
              theme: "red",
              position: "top-right",
              duration: 3000
            });
            return;
          }
          this.showOgrnFind = false;
          this.companyName = data.UF_NAME;
          this.companyId = data.UF_COMPANY_ID;
          this.ogrn = data.UF_OGRN;

          //if (this.lType.UF_IS_BLOCK_ZALOG) {
          //для заголодателей дополнительно выбираем еще блоки обеспечения
          //   this.showProcViewAddBlockZalogDialog = true;
          //  } else {
          this.showProc3();
          //  }

          /*ProjectsService.addBlockDocumentDZ(this.project.ID, {
            UF_SECTION_TYPE_DZ_ID: this.addBlockID,
            UF_TYPE_RESIDENT: this.resident,
            UF_OGRN: data.UF_OGRN,
            UF_COMPANY_NAME: data.UF_NAME,
            UF_COMPANY_ID: data.UF_COMPANY_ID
          }).then(({ data }) => {
            if (!data.error) {
              this.updateDocInfo();
              this.$toasted.show("Блок успешно добавлен", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
            } else {
              data.errorArr.forEach(function(text) {
                this.$toasted.show(text.TEXT, {
                  theme: "red",
                  position: "bottom-right",
                  duration: 3500
                });
              }, this);
            }
          }, this);*/
        }, this);
      } else {
        this.$toasted.show("Необходимо указать ОГРН организации", {
          theme: "red",
          position: "bottom-right",
          duration: 3500
        });
      }
    },
    addSubContactRequest() {
      ProjectsService.addBlockDocumentDZ(this.project.ID, {
        UF_SECTION_TYPE_DZ_ID: this.addBlockID,
        UF_TYPE_RESIDENT: this.resident,
        UF_OGRN: this.ogrn,
        UF_COMPANY_NAME: this.companyName,
        UF_COMPANY_ID: this.companyId,
        UF_TYPE_DOC_LIST: this.selectListType,
        UF_BLOCK_ZALOG_LIST: this.selectListBlock,
        DATA_OLK: this.dataOlk
      }).then(({ data }) => {
        if (!data.error) {
          this.showProc3dialog = false;
          this.showProcViewAddBlockZalogDialog = false;
          this.updateDocInfo();
          this.$toasted.show("Блок успешно добавлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    addInSubContact() {
      ProjectsService.addBlockDocumentDZ(this.project.ID, {
        UF_SECTION_TYPE_DZ_ID: this.addBlockID,
        UF_TYPE_RESIDENT: this.resident,
        UF_COMPANY_NAME: this.inname,
        UF_COMPANY_ID: this.companyId,
        UF_TYPE_DOC_LIST: this.selectListType,
        DATA_OLK: this.dataOlk
      }).then(({ data }) => {
        if (!data.error) {
          this.showCompIn = false;
          this.showProc3dialog = false;
          this.updateDocInfo();
          this.$toasted.show("Блок успешно добавлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    addNotDefinedSubContact() {
      ProjectsService.addBlockDocumentDZ(this.project.ID, {
        UF_SECTION_TYPE_DZ_ID: this.addBlockID,
        UF_TYPE_RESIDENT: "",
        UF_TYPE_DOC_LIST: this.selectListType
      }).then(({ data }) => {
        if (!data.error) {
          this.showResident = false;
          this.showProc3dialog = false;
          this.updateDocInfo();
          this.$toasted.show("Блок успешно добавлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        }
        data.errorArr.forEach(function(text) {
          this.$toasted.show(text.TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        }, this);
      }, this);
    },

    searchAllOrg(query) {
      this.isSearchGood = true;
      if (query !== undefined) {
        ProjectsService.getFindOrgByGetWay({ search: query }).then(({ data }) => {
          this.orgsList = data.items;
          this.isSearchGood = (this.orgsList.length > 0) ? true : false;
        });
      }
    },
    clearAutocomplete() {
      this.selectedOrg = null
      this.orgsList = [];
      this.isAddAllOrgGood = false;
    },
    resetAutocomplete() {
      this.$refs.autoSearchInputRef.searchText = "";
      this.selectedOrg = null;
      this.isAddAllOrgGood = false;
      this.isSearchGood = true;
    },
    selectSearchItems() {
      if (this.selectedOrg && this.selectedOrg.id !== '') {
        this.isAddAllOrgGood = true;
      }
    },
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
      }
    },
    getLinkOlk() {
      return (this.project.META.OLK_COUNTERPARTY_PAGE)?this.project.META.OLK_COUNTERPARTY_PAGE:'https://olk.frprf.ru/counterparty/';
    },
    findСountryByCode(item) {
      if (item && item.counterparty && item.counterparty.countryCode) {
        const result = this.directory.country.filter(
          c => c.CODE === item.counterparty.countryCode
        );
        return result[0];
      }
    },
    setResidentFindOrg() {
      if (this.isAddAllOrgGood) {
        this.resident = (this.selectedOrg.counterparty.type === "ForeignOrganization") ? 2 : 1;

        if (this.resident === 2) {
          let countryId = 0;
          let country = this.findСountryByCode(this.selectedOrg);
          if (country.ID > 0) {
            countryId = country.ID;
          }

          this.inname = this.selectedOrg.counterparty.shortName;
          this.registrationNumber = this.selectedOrg.counterparty.registrationNumber;
          this.companyId = 0;
          this.incountry = countryId;
          this.dataOlk = this.selectedOrg;

        } else {

          this.companyName = (this.selectedOrg.counterparty.ogrnIp)?this.selectedOrg.counterparty.fullName:this.selectedOrg.counterparty.shortName;
          this.ogrn = (this.selectedOrg.counterparty.ogrnIp)?this.selectedOrg.counterparty.ogrnIp:this.selectedOrg.counterparty.ogrn;
          this.companyId = 0;
          this.dataOlk = this.selectedOrg;
        }

        this.showAllSearchOrg = false;
        this.clearAutocomplete();
        this.resetAutocomplete();
        this.showProc3();
      }
    }

  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
